import React, { useMemo } from "react";
import { useLocation } from "react-router";
import { Invitation } from "../components/Invitation";
import { InvitationCampaign } from "../components/Invitation/types/campaign";



export const InvitationScreen: React.FC = () => {
  const { search } = useLocation();
  const { channel, token } = useMemo(() => {
    const queryParams = new URLSearchParams(search);
    return {
      channel: queryParams.get('channel'),
      token: queryParams.get('token')
    }
  }, [search])  

  return (
    <Invitation channel={channel} token={token} campaign={InvitationCampaign.Special_GP}>
      <Invitation.Banner />
      <Invitation.FormSection />
      <Invitation.TermsSection  />
      <Invitation.SuccessSection />
    </Invitation>
   
  );
};